











import { Component, Vue, Prop} from "vue-property-decorator";

@Component({})

export default class CameraIcon extends Vue {
  /* Props */
  @Prop({ default: "#B17A58" })
  public color!: string;
}
